module.exports = __webpack_public_path__ + "3b3b0aa29342fe3654555be816ba859a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-karate-s.png
// module id = 1961
// module chunks = 0